'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {MenuTimerView} from './MenuTimerView';

export class MenuTimerComponent extends Component {
  static propTypes = {
    active: T.number,
    paused: T.number,
    hasTimers: T.bool,
  };

  render() {
    return (
      <MenuTimerView
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/components/MenuTimer/MenuTimerComponent.js